import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  variant?: 'green' | 'terracotta';
}
export function CTAButton({
  children,
  onClick,
  className = '',
  variant = 'green'
}: CTAButtonProps) {
  const baseStyle = 'inline-block rounded-full font-bold uppercase tracking-wide text-white transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-0.5 px-8 py-4 text-sm md:text-base';
  const variants = {
    green: 'bg-brand-green hover:bg-brand-greenDark',
    terracotta: 'bg-brand-terracotta hover:bg-[#b05d31]'
  };
  return <button onClick={onClick} className={`${baseStyle} ${variants[variant]} ${className}`} data-id="element-39">
      {children}
    </button>;
}